/* ==========================================================================
   Hive Keys — infinite product slider
   Transform based with cloned slides at both ends, so next/prev loop for ever
   without a visible scrollbar. Recalculates on resize.
   ========================================================================== */
(function () {
  'use strict';

  function perView(w) {
    if (w < 560) return 1;
    if (w < 860) return 2;
    if (w < 1180) return 3;
    return 4;
  }

  function build(root) {
    var track = root.querySelector('[data-hk-row-track]');
    if (!track || track.dataset.hkReady === '1') return;

    var originals = Array.prototype.slice.call(track.children);
    if (originals.length === 0) return;

    /* fewer slides than a full view: nothing to loop, leave it as a grid */
    if (originals.length <= perView(window.innerWidth)) {
      root.classList.add('is-static');
      track.dataset.hkReady = '1';
      return;
    }

    track.dataset.hkReady = '1';
    var n = originals.length;

    /* clone a full set either side for a seamless wrap */
    originals.forEach(function (el) {
      var a = el.cloneNode(true); a.setAttribute('aria-hidden', 'true'); a.dataset.clone = '1';
      var b = el.cloneNode(true); b.setAttribute('aria-hidden', 'true'); b.dataset.clone = '1';
      track.appendChild(a);
      track.insertBefore(b, track.firstChild);
    });

    var index = n;               // start on the first real slide
    var animating = false;

    function slideWidth() {
      var first = track.children[0];
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function place(withTransition) {
      track.style.transition = withTransition ? 'transform .42s cubic-bezier(.4,.1,.2,1)' : 'none';
      track.style.transform = 'translate3d(' + (-index * slideWidth()) + 'px,0,0)';
    }

    function normalise() {
      if (index >= n * 2) { index -= n; place(false); }
      else if (index < n) { index += n; place(false); }
      animating = false;
    }

    track.addEventListener('transitionend', normalise);

    function go(dir) {
      if (animating) return;
      animating = true;
      index += dir;
      place(true);
      /* transitionend can be missed if the tab is backgrounded */
      setTimeout(function () { if (animating) normalise(); }, 520);
    }

    var prev = root.querySelector('[data-hk-row-prev]');
    var next = root.querySelector('[data-hk-row-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    /* touch swipe */
    var startX = 0, startY = 0, tracking = false;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    }, { passive: true });

    /* laptop trackpad — a two-finger horizontal swipe arrives as wheel deltaX.
       Accumulate so one gesture advances one slide rather than several. */
    var wheelSum = 0, wheelTimer = null;
    root.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;   // vertical scroll: leave the page alone
      e.preventDefault();
      wheelSum += e.deltaX;
      clearTimeout(wheelTimer);
      if (Math.abs(wheelSum) > 60 && !animating) {
        go(wheelSum > 0 ? 1 : -1);
        wheelSum = 0;
      }
      wheelTimer = setTimeout(function () { wheelSum = 0; }, 220);
    }, { passive: false });

    /* mouse drag */
    var down = false, dragX = 0, moved = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; dragX = e.clientX; moved = 0;
      track.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      moved = e.clientX - dragX;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      track.style.cursor = '';
      if (Math.abs(moved) > 60) go(moved < 0 ? 1 : -1);
    });
    /* stop a drag from firing the card link */
    track.addEventListener('click', function (e) {
      if (Math.abs(moved) > 8) { e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);

    place(false);

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { place(false); }, 150);
    });
  }

  function boot() {
    document.querySelectorAll('[data-hk-row]:not(.hk-row--grid)').forEach(build);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* sections re-rendered by the theme editor */
  document.addEventListener('shopify:section:load', boot);
})();
